import { createSlice } from "@reduxjs/toolkit";

export const langMapImages = createSlice({
  name: "lang_map_images",
  initialState: {
    value: { status: false, data: [] },
  },
  reducers: {
    updateLangMapImages: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateLangMapImages } = langMapImages.actions;

export default langMapImages.reducer;
